import * as React from 'react';

export default (name: string, time: string, photo: string, type: string) => {
  return (
    <a href={photo} target={'_blank'}>
      <p>{name}</p>
      <p>{time}</p>
      <p>{type}</p>
      <img
        src={photo}
        alt="拍摄照片"
        style={{ maxWidth: 150, maxHeight: 150, display: 'block' }}
      />
    </a>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/popUp/PhotoView.tsx